import queryString from 'query-string';
import axios from 'axios';

export default {
    logIn(payload: any) {
        
        return axios.post('api/login',
        queryString.stringify(payload), 
        {
            headers: {
                "Content-Type": "x-www-form-urlencoded"
            }
        })
    },
};
